import {
  defaultAppDrawerLogoConfig,
  defaultLoginLogoConfig,
  dreherAppDrawerLogoConfig,
  lacikonyhaAppDrawerDarkLogoConfig,
  lacikonyhaAppDrawerLogoConfig,
  lacikonyhaLoginLogoConfig,
} from '../config/logo-configs';
import { AppCompanies } from '../enums/app-companies';

export const useCompanyLogoConfig = (company: string, isDarkMode: boolean) => {
  const getCompanyLoginLogoSrc = () => {
    if (company === AppCompanies.LACIKONYHA) {
      return '/login-logo.png';
    }

    if (company === AppCompanies.INTERSNACK) {
      return '/leadtech-logo.svg';
    }

    if (company === AppCompanies.DREHER) {
      return '/asahi-logo.svg';
    }

    return '/leadtech-logo.svg';
  };

  const getCompanyLightLogoSrc = () => {
    if (company === AppCompanies.LACIKONYHA) {
      return '/light-logo.png';
    }

    if (company === AppCompanies.INTERSNACK) {
      return '/leadtech-logo.svg';
    }

    if (company === AppCompanies.DREHER) {
      return '/asahi-logo.svg';
    }

    return '/leadtech-logo.svg';
  };

  const getCompanyDarkLogoSrc = () => {
    if (company === AppCompanies.LACIKONYHA) {
      return '/dark-logo.png';
    }

    if (company === AppCompanies.INTERSNACK) {
      return '/leadtech-logo.svg';
    }

    if (company === AppCompanies.DREHER) {
      return '/asahi-logo.svg';
    }

    return '/leadtech-logo.svg';
  };

  const getCompanyLoginLogoConfig = () => {
    if (company === AppCompanies.LACIKONYHA) {
      return lacikonyhaLoginLogoConfig;
    }

    if (company === AppCompanies.INTERSNACK) {
      return defaultLoginLogoConfig;
    }

    return defaultLoginLogoConfig;
  };

  const getCompanyAppDrawerLogoConfig = () => {
    if (company === AppCompanies.LACIKONYHA) {
      return isDarkMode ? lacikonyhaAppDrawerDarkLogoConfig : lacikonyhaAppDrawerLogoConfig;
    }

    if (company === AppCompanies.INTERSNACK) {
      return defaultAppDrawerLogoConfig;
    }

    if (company === AppCompanies.DREHER) {
      return dreherAppDrawerLogoConfig;
    }

    return defaultAppDrawerLogoConfig;
  };

  return {
    getCompanyLightLogoSrc,
    getCompanyDarkLogoSrc,
    getCompanyLoginLogoConfig,
    getCompanyAppDrawerLogoConfig,
    getCompanyLoginLogoSrc,
  };
};
